import { twMerge } from 'tailwind-merge';

interface HeaderContainerProps {
  className?: string;
  children: React.ReactNode;
}

export const HeaderContainer = (props: HeaderContainerProps) => {
  const { children, className } = props;

  return (
    <div
      className={twMerge(
        `z-30 w-full max-w-[100rem] bg-box-primary px-5 lg:px-7 xl:px-[90px] py-3`,
        className
      )}
    >
      {children}
    </div>
  );
};
